var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99219 11.5C5.99219 8.67157 5.99219 7.25736 6.87087 6.37868C7.74955 5.5 9.16376 5.5 11.9922 5.5H14.9922C17.8206 5.5 19.2348 5.5 20.1135 6.37868C20.9922 7.25736 20.9922 8.67157 20.9922 11.5V16.5C20.9922 19.3284 20.9922 20.7426 20.1135 21.6213C19.2348 22.5 17.8206 22.5 14.9922 22.5H11.9922C9.16376 22.5 7.74955 22.5 6.87087 21.6213C5.99219 20.7426 5.99219 19.3284 5.99219 16.5V11.5Z",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99219 19.5C4.33533 19.5 2.99219 18.1569 2.99219 16.5V10.5C2.99219 6.72876 2.99219 4.84315 4.16376 3.67157C5.33533 2.5 7.22095 2.5 10.9922 2.5H14.9922C16.649 2.5 17.9922 3.84315 17.9922 5.5",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/Copy-icon.a565a88ebd074f4dea352dc73ebb9fe6.svg";
export { ForwardRef as ReactComponent };